// функция проверяющая направление листания
$(function(){
    $.fn.swipe = function(callback){
        var touchDown = false,
            originalPosition = null,
            $el = $(this);

        function swipeInfo(event){

            var x, y, dx, dy;
            if(event.type == 'touchmove'){
                x = event.originalEvent.touches[0].pageX;
                y = event.originalEvent.touches[0].pageY;
            }
            if(event.type == 'mousemove'){
                x = event.originalEvent.pageX;
                y = event.originalEvent.pageY;
            }

            dx = ( x > originalPosition.x ) ? "right" : "left";
            dy = ( y > originalPosition.y ) ? "down" : "up";

            return {
                direction: {
                    x: dx,
                    y: dy
                },
                offset: {
                    x: x - originalPosition.x,
                    y: originalPosition.y - y
                }
            };
        }

        $el.on("touchstart mousedown", function(event){
            touchDown = true;
            if(event.type == 'touchstart'){
                originalPosition = {
                    x: event.originalEvent.touches[0].pageX,
                    y: event.originalEvent.touches[0].pageY
                };
            }
            if(event.type == 'mousedown'){
                originalPosition = {
                    x: event.originalEvent.pageX,
                    y: event.originalEvent.pageY
                };
            }
        });

        $el.on("touchend mouseup", function(){
            touchDown = false;
            originalPosition = null;
        });

        $el.on("touchmove mousemove", function(event){
            if(!touchDown){
                return;
            }
            var info = swipeInfo(event);
            callback(this, info.direction, info.offset);
        });
        return true;
    };
});